import {Injectable} from "@angular/core";
import {Resolve} from "@angular/router";
import {Observable} from 'rxjs/Observable';
import {IPaiementWebServiceClient, PaiementDto} from "@resources/resources";
import {PaiementStore} from "./paiement.store";

@Injectable()
export class PaiementResolver implements Resolve<PaiementDto[]> {

  constructor(private paiementWebServiceClient: IPaiementWebServiceClient,
              private paiementStore: PaiementStore) {
  }

  resolve() {
    let key = this.paiementStore.getPaiementKey();
    this.paiementStore.setPaiementKey(null);
    return key ? this.paiementWebServiceClient.findPaiementEncours(key) : Observable.of([]);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-paiement-factures/digicerba-paiement-factures-web/src/angular/cerba/src/app/pages/cerba/pages/paiement.resolver.ts